import React, { useState, useEffect } from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import { getLandingPageBySlug } from '../../service/api';

const menuDataTwo = [
  { title: 'Bài viết', href: '/blog' },
  { title: 'Liên hệ', href: '/contact' },
  { title: 'Chính sách bảo mật', href: '/privacy-policy' },
  { title: 'Điều khoản và điều kiện', href: '/terms-and-conditions' },
];

export default function Footer() {
  const [data, setData] = useState(null);
  const content = data?.content || {};

  const fetchData = async () => {
    try {
      const data = await getLandingPageBySlug('footer');
      setData(data);
    } catch (error) {
      console.error('Error fetching landing page:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <footer className='cs_footer cs_style_1 cs_heading_color'>
      <div
        className='cs_footer_logo_wrap'
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        {/* <div
          className='cs_footer_brand'
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src='/images/logo_icon.svg'
            alt='Logo Icon'
            className='cs_footer_brand_icon'
          />
          <h2 className='cs_footer_brand_text'>ProHealth</h2>
        </div> */}
      </div>
      <div className='cs_footer_main'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-4'>
              <div className='cs_footer_item'>
                <TextWidget text={content?.introduction?.title} />
                <ContactInfoWidget data={content?.introduction} />
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='cs_footer_item'>
                <MenuWidget data={menuDataTwo} />
              </div>
            </div>
            <div className='col-lg-4'>
              <div className='cs_footer_item'>
                <Newsletter
                  title='Hãy là người đăng ký của chúng tôi'
                  subTitle='Để nhận được những tin tức mới nhất về sức khỏe từ các chuyên gia của chúng tôi'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='cs_footer_bottom cs_accent_bg'>
        <div className='container'>
          <div className='cs_footer_bottom_in'>
            <SocialWidget data={content?.introduction} />
            <div className='cs_copyright'>
              Copyright © 2025 Tien Duc. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
